import type { GeneralFormValues } from '../../../../../common';

export const GENERAL_INFO_FIELD_NAMES = [
  'provider_full_name',
  'provider_email',
  'primary_language',
  'relationship_to_client',
  'client_first_name',
  'client_middle_name',
  'client_last_name',
  'client_date_of_birth',
  'client_sex',
  'client_address_same_as_provider',
  'client_street_address_line_one',
  'client_street_address_line_two',
  'client_street_address_zip',
  'client_street_address_city',
  'client_street_address_state',
] as const;

export const GENERAL_INITIAL_VALUES: GeneralFormValues = {
  provider_full_name: '',
  provider_email: '',
  primary_language: '',
  relationship_to_client: '',
  client_first_name: '',
  client_middle_name: '',
  client_last_name: '',
  client_date_of_birth: null,
  client_sex: '',
  client_address_same_as_provider: false,
  client_street_address_line_one: '',
  client_street_address_line_two: '',
  client_street_address_zip: '',
  client_street_address_city: '',
  client_street_address_state: '',
};

export const CLIENT_ADDRESS_SAME_AS_PROVIDER_FIELD_NAME = 'client_address_same_as_provider';

export const CLIENT_ADDRESS_FIELD_NAMES = [
  'client_street_address_line_one',
  'client_street_address_line_two',
  'client_street_address_city',
  'client_street_address_state',
  'client_street_address_zip',
] as const;

export const PROVIDER_TO_CLIENT_ADDRESS_FIELDS = [
  ['street_address_line_one', 'client_street_address_line_one'],
  ['street_address_line_two', 'client_street_address_line_two'],
  ['street_address_city', 'client_street_address_city'],
  ['street_address_state', 'client_street_address_state'],
  ['street_address_zip', 'client_street_address_zip'],
] as const;

export const PROVIDER_REQUIRED_ADDRESS_FIELD_NAMES = [
  'street_address_line_one',
  'street_address_city',
  'street_address_state',
] as const;
